import { render, staticRenderFns } from "./icon-positive-new-ux.vue?vue&type=template&id=f7edbdc0&"
import script from "./icon-positive-new-ux.vue?vue&type=script&lang=js&"
export * from "./icon-positive-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7edbdc0')) {
      api.createRecord('f7edbdc0', component.options)
    } else {
      api.reload('f7edbdc0', component.options)
    }
    module.hot.accept("./icon-positive-new-ux.vue?vue&type=template&id=f7edbdc0&", function () {
      api.rerender('f7edbdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/icon-positive-new-ux.vue"
export default component.exports